/* Committed URLs match the production native scheme (playgroundNative/.env.production):
 * the production app host and the production website login as the Apple redirect.
 *
 * Local scheme (playgroundNative/.env.local): point baseUrlForApi and baseUrlForWebsite
 * at the same environment as that file's WEB_APP_URL.
 * Dev scheme (playgroundNative/.env.dev): point them at the dev environment when that
 * scheme is the one running.
 */

export const baseUrlForApi = "https://api.playgroundsessions.com";
export const baseUrlForWebsite = "https://www.playgroundsessions.com";
export const recaptchaV3SiteKey = "6LfqV78aAAAAAPHeAxaI__5u9nbl6AfhEAJWnlR9";
